import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import "./Dashboard.css";
import {
  Button,
  CircularProgress,
  Container,
  Skeleton,
  IconButton,
  Modal,
} from "@mui/material";
import { Link } from "react-router-dom";
import TripDetail from "../TripDetails/TripDetails";
import { useNavigate } from "react-router-dom";
// import TripChart from "../TripDetails/TripChart";
import LiveRounded from "../../assets/images/dashboard/LiveRounded.svg";
import ChartJs from "../charts/ChartJs";
import TripServices from "../services/externalServices/tripServices";
import UserServices from "../services/externalServices/userServices";
import RiderServices from "../services/externalServices/riderServices";
import TopRiders from "../Riders/TopRiders";
import TopUsers from "../user-pages/TopUsers";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MapView from "../map/MapView";
// import TripChartNew from "../TripDetails/TripChart_new";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TripChart from "../charts/TripChart";

import {
  Card,
  CardContent,
  Stack,
  Avatar,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import GroupIcon from "@mui/icons-material/Group";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import UserChart from "../charts/UserChart";
import TripTrafficChart from "../charts/TripTrafficChart";
import OnGoingTrip from "../TripDetails/OnGoingTrip";
import TripsMap from "../map/TripsMap";
import CruzeScanServices from "../services/externalServices/TourPackageServices/cruzeScanServices";
import ScannedDataDetails from "../scans/ScannedDataDetails";
import { useDispatch, useSelector } from "react-redux";
import { fetchTripDetails } from "../redux/slice/tripSlice";
import RefreshIcon from "@mui/icons-material/Refresh";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { serviceType } = useSelector(
    (state) => state.serviceType?.serviceType
  );
  const { data: tripData } = useSelector((state) => state.trip?.data || {});
  const loading = useSelector((state) => state.trip?.loading);
  const currentServiceType = useSelector(
    (state) => state.trip?.currentServiceType
  );

  const [selectedItem, setSelectedItem] = useState("All time");

  const [completedTrips, setCompletedTrips] = useState(null);
  const [cancelledTrips, setCancelledTrips] = useState(null);
  const [users, setUsers] = useState([]);
  const [totalEarning, setTotalEarning] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [trip, setTrip] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeDriversCount, setActiveDriversCount] = useState(0);
  const [activeDriversWithNoTripAssigned, setActiveDriversWithNoTripAssigned] =
    useState(0);
  const [activeDriversWithTripAssigned, setActiveDriversWithTripAssigned] =
    useState(0);
  const [onGoingTrips, setOnGoingTrips] = useState(0);
  const navigation = useNavigate();
  // ];
  const [topRiders, setTopRiders] = useState([]);
  const [selectedTripType, setSelectedTripType] = useState(null);
  const [trips, setTrips] = useState(null);

  const [bookedTrips, setBookedTrips] = useState(null);
  const [timeInterval, setTimeInterval] = useState("1_hour");
  const [driversData, setDriversData] = useState([]);
  const [scannedData, setScannedData] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [activeDriversList, setActiveDriversList] = useState([]);
  // const [pricingData,setPricingData]=useState(null)
  const [showDetails, setShowDetails] = useState(false);
  const [totalDetails, setTotalDetails] = useState(null);

  const handleTripTypeClick = (tripType) => {
    setSelectedTripType(tripType);
    if (tripType === "onGoingTrip") {
      // Navigate to the "OnGoing Trips" screen
      navigation.navigate("/trip/onGoingTrip");
    }
  };

  useEffect(() => {
    console.log("====================serviceType", serviceType);
    console.log("====================currentServiceType", currentServiceType);
    if (currentServiceType !== serviceType) {
      setIsLoading(true);
      dispatch(fetchTripDetails(serviceType)).finally(() =>
        setIsLoading(false)
      );
    }
  }, [dispatch, serviceType, tripData, currentServiceType]);

  const refreshData = async () => {
    setIsLoading(true);
    dispatch(fetchTripDetails(serviceType)).finally(() => setIsLoading(false));
  };

  // Process trip data when it updates
  //   useEffect(() => {
  //     console.log("tripData",tripData)
  //     if (tripData?.length > 0) {
  //       const bookedTrips = tripData.filter(
  //         (trip) => trip.status === "BOOKED" && trip.paymentStatus === "SUCCESS"
  //       ).length;
  // console.log("bookedTrips",bookedTrips)
  //     // const totalTrips=tripData.length
  //       const completedTrips = tripData.filter(
  //         (trip) => trip.status === "TRIP_ENDED"
  //       ).length;

  //       const ongoingTrips = tripData.filter(
  //         (trip) => trip.status === "ON_THE_WAY" || trip.status === "TRIP_STARTED"
  //       );

  //       const initiatedTrips = tripData.filter(
  //         (trip) => trip.status === "INITIATED"
  //       ).length;

  //       const cancelledTrips = tripData.filter(
  //         (trip) => trip.status === "CANCELLED"
  //       ).length;

  //       const totalCancelledTrips = initiatedTrips + cancelledTrips;

  //       setBookedTrips(bookedTrips);
  //       setCompletedTrips(completedTrips);
  //       setOnGoingTrips(ongoingTrips);
  //       setCancelledTrips(totalCancelledTrips);
  //     }
  //   }, [tripData]);

  useEffect(() => {
    console.log("tripData", tripData);

    if (tripData?.length > 0) {
      const bookedTrips = tripData.filter(
        (trip) => trip.status === "BOOKED" && trip.paymentStatus === "SUCCESS"
      ).length;

      console.log("bookedTrips", bookedTrips);

      const completedTrips = tripData.filter(
        (trip) => trip.status === "TRIP_ENDED"
      ).length;

      const ongoingTrips = tripData.filter(
        (trip) => trip.status === "ON_THE_WAY" || trip.status === "TRIP_STARTED"
      ).length;

      const initiatedTrips = tripData.filter(
        (trip) => trip.status === "INITIATED"
      ).length;

      const cancelledTrips = tripData.filter(
        (trip) => trip.status === "CANCELLED"
      ).length;

      const totalCancelledTrips = initiatedTrips + cancelledTrips;

      setBookedTrips(bookedTrips);
      setCompletedTrips(completedTrips);
      setOnGoingTrips(ongoingTrips);
      setCancelledTrips(totalCancelledTrips);
    } else {
      // If tripData is empty or null, set all values to 0
      console.log("in else part");
      setBookedTrips(0);
      setCompletedTrips(0);
      setOnGoingTrips(0);
      setCancelledTrips(0);
    }
  }, [tripData]);

  const getTotalScans = async () => {
    try {
      const response = await CruzeScanServices.getScannedData();
      console.log("scanned data", response);
      setScannedData(response);
    } catch (error) {
      console.log("error while getting the scanner", error);
    }
  };

  //   const getTotalAmount = async () => {
  //     try {
  //       // setIsLoading(true);
  //       // Fetch trip prices based on the selected time interval
  //       console.log("getTripPrice is called");

  //       const tripsBid = await TripServices.getTripBid(serviceType);

  // console.log("tripsBid",tripsBid);
  //       // Filter trips that have ended
  //       const tripsEnded = tripsBid.filter(
  //         (trip) =>
  //           trip.status === "TRIP_ENDED" &&
  //           trip.paymentDetails?.state === "COMPLETED"
  //       );
  //       console.log("TRIP_ENDED", tripsEnded);
  //       if (tripsEnded.length > 0) {
  //         // Calculate total amount earned from ended trips
  //         const totalAmount = tripsEnded.reduce((acc, trip) => {
  //           if (trip.bid && trip.bid.amount) {
  //             acc += trip.bid.amount;
  //           }
  //           return acc;
  //         }, 0);

  //         // Round the total amount to 2 decimal places
  //         const roundedTotalAmount = Number(totalAmount.toFixed(2));
  //         console.log("roundedTotalAmount", roundedTotalAmount);
  //         // Set the total amount state
  //         setTotalEarning(roundedTotalAmount);
  //       } else {
  //         // If no ended trips found, set total amount to 0
  //         setTotalEarning(0);
  //       }
  //     } catch (err) {
  //       console.log("Error fetching trip prices:", err);
  //     }
  //   };

  const getTotalAmount = async () => {
    try {
      console.log("getTripPrice is called");
  
      // Fetch trip prices based on the selected time interval
      const tripsBid = await TripServices.getTripBid(serviceType);
  
      console.log("tripsBid", tripsBid);
  
      if (tripsBid && tripsBid.length > 0) {
        // Filter trips that have ended
        const tripsEnded = tripsBid.filter(
          (trip) =>
            trip.status === "TRIP_ENDED" &&
            trip.paymentDetails?.state === "COMPLETED"
        );
        console.log("TRIP_ENDED=======", tripsEnded);
  
        if (tripsEnded.length > 0) {
          // Calculate total amount earned from ended trips
          const totalAmount = tripsEnded.reduce((acc, trip) => {
            if (trip.pricing.finalAmount) {
              acc += trip.pricing.finalAmount; // Sum finalAmount for each trip
            }
            return acc;
          }, 0);
  
          const detailedPricing = tripsEnded.map((trip) => ({
            baseAmount: trip.pricing.baseAmount,
            discount: trip.pricing.discount,
            tax: trip.pricing.tax,
            platformFee: trip.pricing.platformFee,
            tds: trip.pricing.tds,
            finalAmount: trip.pricing.finalAmount,
          }));
          console.log("detailedPricing",detailedPricing)

          // Calculate totals for all pricing fields
          const totals = tripsEnded.reduce(
            (acc, trip) => {
              if (trip.pricing.baseAmount?.value)
                acc.baseAmount += trip.pricing.baseAmount.value;
              if (trip.pricing.discount?.value)
                acc.discount += trip.pricing.discount.value;
              if (trip.pricing.tax?.total?.value)
                acc.tax += trip.pricing.tax.total.value;
              if (trip.pricing.platformFee?.netFee?.value)
                acc.platformFee += trip.pricing.platformFee.netFee.value;
              if (trip.pricing.tds?.value) acc.tds += trip.pricing.tds.value;
              if (trip.pricing.finalAmount)
                acc.finalAmount += trip.pricing.finalAmount;
              return acc;
            },
            {
              baseAmount: 0,
              discount: 0,
              tax: 0,
              platformFee: 0,
              tds: 0,
              finalAmount: 0,
            }
          );
  
          // Round all totals to 2 decimal places
          const roundedTotals = {
            RiderFee: Number(totals.baseAmount.toFixed(2)),
            discount: Number(totals.discount.toFixed(2)),
            tax: Number(totals.tax.toFixed(2)),
            platformFee: Number(totals.platformFee.toFixed(2)),
            tds: Number(totals.tds.toFixed(2)),
            finalAmount: Number(totals.finalAmount.toFixed(2)),
          };
  
          console.log("roundedTotals", roundedTotals);
  
          // Update the state
          setTotalEarning(Number(totalAmount.toFixed(2)));
          setTotalDetails(roundedTotals);
        } else {
          // No trips have ended, reset the state
          console.log("No ended trips found, resetting totals");
          setTotalEarning(0);
          setTotalDetails({
            RiderFee: 0,
            discount: 0,
            tax: 0,
            platformFee: 0,
            tds: 0,
            finalAmount: 0,
          });
        }
      } else {
        // If tripsBid is null, undefined, or empty, reset the state
        console.log("No tripsBid data available, resetting totals");
        setTotalEarning(0);
        setTotalDetails({
          RiderFee: 0,
          discount: 0,
          tax: 0,
          platformFee: 0,
          tds: 0,
          finalAmount: 0,
        });
      }
    } catch (err) {
      console.log("Error fetching trip prices:", err);
      // Reset state in case of an error
      setTotalEarning(0);
      setTotalDetails({
        RiderFee: 0,
        discount: 0,
        tax: 0,
        platformFee: 0,
        tds: 0,
        finalAmount: 0,
      });
    }
  };
  

  const getActiveUserCount = async () => {
    // const response = await axios.get("http://localhost:8080/users");
    const usersData = await UserServices.getAllUsers();
    // const activeUsersCount = usersData.filter((user) => user.is_active).length;

    setUsers(usersData);
  };

  const getActiveDrivers = async () => {
    // const response = await axios.get("http://localhost:8080/riders");
    // setIsLoading(true);
    const driverData = await RiderServices.getDriversDashBoard(serviceType);
    setDriversData(driverData);

    // const driverData = response.data;
    const activeDriverCount = driverData.filter(
      (driver) => driver.is_online && driver.is_approved
    ).length;
    setActiveDriversCount(activeDriverCount);
    console.log("driverData", driverData);
    const activeDriversWithNoTripAssigned = driverData.filter(
      (driver) => driver.is_online && !driver.isOccupied
    ).length;
    setActiveDriversWithNoTripAssigned(activeDriversWithNoTripAssigned);
    console.log(
      "active drivers without trips",
      activeDriversWithNoTripAssigned
    );
    const activeDriversWithTripAssigned = driverData.filter(
      (driver) => driver.is_online && driver.isOccupied
    ).length;
    setActiveDriversWithTripAssigned(activeDriversWithTripAssigned);
    console.log("active drivers with trips", activeDriversWithTripAssigned);
  };

  const loader = () => {
    return <CircularProgress sx={{ color: "#667085", marginTop: "3px" }} />;
  };

  useEffect(() => {
    // getTripCounts(selectedItem);
    getActiveUserCount();
    getActiveDrivers();
    getTotalAmount();
    getTotalScans();
  }, [serviceType]);

  // Function to handle opening the modal
  const handleOpenModal = () => {
    // Filter active drivers
    const filteredActiveDrivers = driversData.filter(
      (driver) => driver.is_online && driver.is_approved
    );
    setActiveDriversList(filteredActiveDrivers);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCardClick = () => {
    setShowDetails((prev) => !prev); // Toggle details on card click
  };

  return (
    // <div className="container">
    <Container>
      <Box marginTop={5}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          marginBottom={2}
        >
          <Typography variant="h4" color="#667085">
            Overview
          </Typography>
          <IconButton
            color="primary"
            aria-label="refresh"
            onClick={() => refreshData()}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Link to="/trips" style={{ textDecoration: "none" }}>
              <Card elevation={2} sx={{ borderRadius: 5 }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Paper
                      elevation={3}
                      style={{
                        backgroundColor: "white",
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar style={{ backgroundColor: "white" }}>
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M8.57385 20.3523L11.9553 13.5894C11.9737 13.5526 12.0263 13.5526 12.0447 13.5894L15.4261 20.3523C15.4483 20.3965 15.3996 20.4426 15.3566 20.4181L12.0248 18.5142C12.0094 18.5054 11.9906 18.5054 11.9752 18.5142L8.64338 20.4181C8.60043 20.4426 8.55173 20.3965 8.57385 20.3523Z"
                              stroke="#33363F"
                              stroke-linecap="round"
                            ></path>{" "}
                            <path
                              d="M20.5 18.5L16.5 3.5"
                              stroke="#33363F"
                              stroke-linecap="round"
                            ></path>{" "}
                            <path
                              d="M3.5 18.5L7.5 3.5"
                              stroke="#33363F"
                              stroke-linecap="round"
                            ></path>{" "}
                            <path
                              d="M12 10.5V8.5"
                              stroke="#33363F"
                              stroke-linecap="round"
                            ></path>{" "}
                            <path
                              d="M12 5.5V3.5"
                              stroke="#33363F"
                              stroke-linecap="round"
                            ></path>{" "}
                          </g>
                        </svg>
                      </Avatar>
                    </Paper>
                    <div>
                      <Typography variant="body1" style={{ color: "#667085" }}>
                        OnGoing Trips
                      </Typography>
                      {isLoading ? (
                        loader()
                      ) : (
                        <Typography variant="h4">{onGoingTrips}</Typography>
                      )}
                    </div>
                  </Stack>
                </CardContent>
                <Divider />
                <Box padding={2}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TrendingUpIcon fontSize="medium" />
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      <Typography variant="subtitle2" component="span">
                        15%
                      </Typography>{" "}
                      increase vs last month
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </Link>
          </Grid>

          {/* completed Trips */}

          <Grid item xs={12} sm={6} md={3}>
            <Link to="/trips" style={{ textDecoration: "none" }}>
              <Card elevation={2} sx={{ borderRadius: 5 }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Paper
                      elevation={3}
                      style={{
                        backgroundColor: "white",
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar style={{ backgroundColor: "white" }}>
                        {/* <ReportProblemIcon fontSize="large" /> */}
                        <svg
                          viewBox="0 -0.5 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M5.5 12.5L10.167 17L19.5 8"
                              stroke=" #008000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                          </g>
                        </svg>
                      </Avatar>
                    </Paper>
                    <div>
                      <Typography variant="body1" style={{ color: "#667085" }}>
                        Completed Trips
                      </Typography>
                      {isLoading ? (
                        loader()
                      ) : (
                        <Typography variant="h4">{completedTrips}</Typography>
                      )}
                    </div>
                  </Stack>
                </CardContent>
                <Divider />
                <Box padding={2}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TrendingUpIcon fontSize="medium" />
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      <Typography variant="subtitle2" component="span">
                        12%
                      </Typography>{" "}
                      increase vs last month
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </Link>
          </Grid>

          {/* cancelled trips */}

          <Grid item xs={12} sm={6} md={3}>
            <Link to="/trips" style={{ textDecoration: "none" }}>
              <Card elevation={2} sx={{ borderRadius: 5 }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Paper
                      elevation={3}
                      style={{
                        backgroundColor: "white",
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar style={{ backgroundColor: "white" }}>
                        {/* <ReportProblemIcon fontSize="large" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 -960 960 960"
                          width="24px"
                          fill="#EA3323"
                        >
                          <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" />
                        </svg>
                      </Avatar>
                    </Paper>
                    <div>
                      <Typography variant="body1" style={{ color: "#667085" }}>
                        Cancelled Trips
                      </Typography>
                      {isLoading ? (
                        loader()
                      ) : (
                        <Typography variant="h4">{cancelledTrips}</Typography>
                      )}
                    </div>
                  </Stack>
                </CardContent>
                <Divider />
                <Box padding={2}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TrendingUpIcon fontSize="medium" />
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      <Typography variant="subtitle2" component="span">
                        12%
                      </Typography>{" "}
                      increase vs last month
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Link to="/trips" style={{ textDecoration: "none" }}>
              <Card elevation={2} sx={{ borderRadius: 5 }}>
                <CardContent>
                  <Stack
                    direction="row"
                    spacing={4}
                    alignItems="left"
                    justifyContent="space-between"
                  >
                    {/* Trips Section */}
                    <Stack direction="row" spacing={2} alignItems="center">
                      <div>
                        <Typography
                          variant="body1"
                          style={{ color: "#667085" }}
                        >
                          Total Trips
                        </Typography>
                        {isLoading ? (
                          loader()
                        ) : (
                          <Typography variant="h4">
                            {tripData?.length}
                          </Typography>
                        )}
                      </div>
                    </Stack>

                    <div>
                      <Typography variant="body1" style={{ color: "#667085" }}>
                        Currently Booked Trips
                      </Typography>
                      {isLoading ? (
                        loader()
                      ) : (
                        <Typography variant="h4">{bookedTrips}</Typography>
                      )}
                    </div>
                  </Stack>
                </CardContent>
                <Divider />
                <Box padding={2}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TrendingUpIcon fontSize="medium" />
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      <Typography variant="subtitle2" component="span">
                        12%
                      </Typography>{" "}
                      increase vs last month
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </Link>
          </Grid>

          {/* Earnings */}

          <Grid item xs={12} sm={6} md={3}>
      <Card elevation={2} sx={{ borderRadius: 5 }} onClick={handleCardClick} style={{ cursor: "pointer" }}>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <Paper
              elevation={3}
              style={{
                backgroundColor: "white",
                width: 50,
                height: 50,
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar style={{ backgroundColor: "white" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#5f6368"
                >
                  <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                </svg>
              </Avatar>
            </Paper>

            <div>
              <Typography variant="body1" style={{ color: "#667085" }}>
                Earnings
              </Typography>
              {totalEarning !== null && totalEarning !== undefined ? (
                <Typography variant="h4">{totalEarning}</Typography>
              ) : (
                loader()
              )}
            </div>
          </Stack>
        </CardContent>
        <Divider />
        <Box padding={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <TrendingUpIcon fontSize="medium" />
            <Typography variant="body2" style={{ color: "#667085" }}>
              <Typography variant="subtitle2" component="span">
                12%
              </Typography>{" "}
              increase vs last month
            </Typography>
          </Stack>
        </Box>
        {/* Displaying Total Details when clicked */}
     
      </Card>
    </Grid>

    {showDetails && totalDetails && (
          <Box
            padding={2}
            style={{
              backgroundColor: "#f9f9f9",
              borderRadius: "8px",
              marginTop: "10px",
            }}
          >
            <Typography variant="body1">
              <strong>Rider Fee:</strong> ₹{totalDetails.RiderFee}
            </Typography>
            <Typography variant="body1">
              <strong>Discount:</strong> ₹{totalDetails.discount}
            </Typography>
            <Typography variant="body1">
              <strong>Total Tax:</strong> ₹{totalDetails.tax}
            </Typography>
            <Typography variant="body1">
              <strong>Platform Fee:</strong> ₹{totalDetails.platformFee}
            </Typography>
            <Typography variant="body1">
              <strong>TDS Amount:</strong> ₹{totalDetails.tds}
            </Typography>
            <Typography variant="body1">
              <strong>Driver Amount After TDS:</strong> ₹
              {totalDetails.driverAmountAfterTDS || 0}
            </Typography>{" "}
            {/* If available */}
            <Typography variant="body1">
              <strong>Grand Total:</strong> ₹{totalDetails.finalAmount}
            </Typography>
          </Box>
        )}

          <Grid item xs={12} sm={6} md={3}>
            <Card elevation={2} sx={{ borderRadius: 5 }}>
              <CardContent>
                <Stack
                  direction="row"
                  spacing={4}
                  alignItems="left"
                  justifyContent="space-between"
                >
                  {/* Trips Section */}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <div>
                      <Link
                        to="/riders"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <Typography
                          variant="body1"
                          style={{ color: "#667085" }}
                        >
                          Total Driver
                        </Typography>
                        {isLoading ? (
                          loader()
                        ) : (
                          <Typography variant="h4">
                            {driversData.length}
                          </Typography>
                        )}
                      </Link>
                    </div>
                  </Stack>

                  <div
                    onClick={() => handleOpenModal()}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography variant="body1" style={{ color: "#667085" }}>
                      Active Drivers
                    </Typography>
                    {isLoading ? (
                      loader()
                    ) : (
                      <Typography variant="h4">{activeDriversCount}</Typography>
                    )}
                  </div>
                </Stack>
              </CardContent>
              <Divider />
              <Box padding={2}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <TrendingUpIcon fontSize="medium" />
                  <Typography variant="body2" style={{ color: "#667085" }}>
                    <Typography variant="subtitle2" component="span">
                      12%
                    </Typography>{" "}
                    increase vs last month
                  </Typography>
                </Stack>
              </Box>
            </Card>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Link to="/users" style={{ textDecoration: "none" }}>
              <Card elevation={2} sx={{ borderRadius: 5 }}>
                <CardContent>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Paper
                      elevation={3}
                      style={{
                        backgroundColor: "white",
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Avatar style={{ backgroundColor: "white" }}>
                        {/* <GroupIcon fontSize="large" /> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1em"
                          height="1em"
                          fill="black"
                          viewBox="0 0 256 256"
                          font-size="var(--icon-fontSize-lg)"
                        >
                          <path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"></path>
                        </svg>
                        {/* <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.1992 12C12.9606 12 15.1992 9.76142 15.1992 7C15.1992 4.23858 12.9606 2 10.1992 2C7.43779 2 5.19922 4.23858 5.19922 7C5.19922 9.76142 7.43779 12 10.1992 12Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M1 22C1.57038 20.0332 2.74795 18.2971 4.36438 17.0399C5.98081 15.7827 7.95335 15.0687 10 15C14.12 15 17.63 17.91 19 22" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.8205 4.44006C18.5822 4.83059 19.1986 5.45518 19.579 6.22205C19.9594 6.98891 20.0838 7.85753 19.9338 8.70032C19.7838 9.5431 19.3674 10.3155 18.7458 10.9041C18.1243 11.4926 17.3302 11.8662 16.4805 11.97" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.3203 14.5701C18.6543 14.91 19.8779 15.5883 20.8729 16.5396C21.868 17.4908 22.6007 18.6827 23.0003 20" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> */}
                      </Avatar>
                    </Paper>
                    <div>
                      <Typography variant="body1" style={{ color: "#667085" }}>
                        Sign ups
                      </Typography>
                      {users.length >= 1 ? (
                        <Typography variant="h4">{users.length}</Typography>
                      ) : (
                        loader()
                      )}
                    </div>
                  </Stack>
                </CardContent>
                <Divider />
                <Box padding={2}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <TrendingDownIcon fontSize="medium" />
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      <Typography variant="subtitle2" component="span">
                        5%
                      </Typography>{" "}
                      decrease vs last month
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </Link>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Card elevation={2} sx={{ borderRadius: 5 }}>
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Paper
                    elevation={3}
                    style={{
                      backgroundColor: "white",
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Avatar style={{ backgroundColor: "white" }}>
                      {/* <ReportProblemIcon fontSize="large" /> */}
                      <svg
                        viewBox="0 -0.5 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></g>
                        <g id="SVGRepo_iconCarrier">
                          {" "}
                          <path
                            d="M5.5 12.5L10.167 17L19.5 8"
                            stroke=" #008000"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>{" "}
                        </g>
                      </svg>
                    </Avatar>
                  </Paper>
                  <div>
                    <Typography variant="body1" style={{ color: "#667085" }}>
                      Total Scans
                    </Typography>
                    {isLoading ? (
                      loader()
                    ) : (
                      <Typography variant="h4">{scannedData.length}</Typography>
                    )}
                  </div>
                </Stack>
              </CardContent>
              <Divider />
              <Box padding={2}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <TrendingUpIcon fontSize="medium" />
                  <Typography variant="body2" style={{ color: "#667085" }}>
                    <Typography variant="subtitle2" component="span">
                      12%
                    </Typography>{" "}
                    increase vs last month
                  </Typography>
                </Stack>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Active Drivers Modal */}

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" style={{ marginBottom: "16px" }}>
            Active Drivers List
          </Typography>
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            {activeDriversList.length > 0 ? (
              activeDriversList.map((driver) => (
                <Box
                  key={driver._id} // Assuming `_id` is unique
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <div>
                    <Typography variant="body1">
                      {driver.first_name} {driver.last_name}
                    </Typography>
                    <Typography variant="body2" style={{ color: "#667085" }}>
                      PhoneNumber: {driver.phone_number}
                    </Typography>
                  </div>
                </Box>
              ))
            ) : (
              <Typography variant="body2" style={{ color: "#667085" }}>
                No active drivers found.
              </Typography>
            )}
          </div>
        </Box>
      </Modal>

      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card card-box">
            <div className="card-head">
              <h4 className="card-title">Taxi Live Location</h4>
            </div>
            <div className="card-body">
              <div className="map-container">
                <MapView driversData={driversData} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Grid container spacing={2} direction={{ xs: "column", md: "row" }}>
        <Grid item xs={12}>
          <ScannedDataDetails scannedData={scannedData} />
        </Grid>
      </Grid>

      <Grid container spacing={2} direction={{ xs: "column", md: "row" }}>
        <Grid item xs={12}>
          {users.length >= 1 && (
            <UserChart userData={users} driverData={driversData} />
          )}
        </Grid>
      </Grid>

      <Grid container spacing={2} marginTop="10px">
        <Grid item xs={12} md={12}>
          <OnGoingTrip />
        </Grid>
        <Grid item xs={12} md={6}>
          <TripChart />
        </Grid>
        <Grid item xs={12} md={6}>
          <TripTrafficChart />
        </Grid>
      </Grid>
      {/* <Grid container spacing={2} marginTop="10px"> */}

      {/* </Grid> */}
    </Container>
  );
};

export default Dashboard;
